import * as React from 'react';
import {
  DisplayText,
  Subheading,
  TextContainer,
  TextStyle,
} from '@shopify/polaris';
import {
  Heading,
  ServiceMetrics,
  Paragraph,
} from 'sections/services-marketplace/experts/components';
import {
  PublicMetrics,
  PublicServiceListing,
  ServiceQuestion,
} from 'sections/types';
import {fetchTaxonomy} from 'sections/services-marketplace/experts/utilities';

import * as styles from './ServiceDetails.scss';

interface OwnProps {
  serviceListing: PublicServiceListing;
  metrics?: PublicMetrics;
}

export default function ServiceDetails({serviceListing, metrics}: OwnProps) {
  const taxonomy = fetchTaxonomy();
  const ancestors = taxonomy.getAncestors(serviceListing.handle);

  return (
    <div className={styles.ServiceDetails}>
      <TextContainer spacing="tight">
        {ancestors.length ? (
          <Subheading>
            <TextStyle variation="subdued">
              {ancestors.map(service => service.label).join(' > ')}
            </TextStyle>
          </Subheading>
        ) : null}
        <DisplayText element="h2" size="large">
          {serviceListing.shortLabel}
        </DisplayText>
        <DisplayText element="p" size="small">
          <TextStyle variation="subdued">
            {serviceListing.description}
          </TextStyle>
        </DisplayText>
      </TextContainer>
      {metrics && (
        <div className={styles.ServiceMetricsContainer}>
          <ServiceMetrics
            price={serviceListing.startingPrice}
            jobsCompleted={metrics.totalJobsCompleted}
            overallRating={metrics.averageRating}
            totalReviews={metrics.totalReviews}
            variation="ServiceDetails"
          />
        </div>
      )}
      {serviceListing.serviceQuestions && (
        <div className={styles.QuestionsAnswers}>
          {serviceListing.serviceQuestions.map((item: ServiceQuestion) => (
            <TextContainer key={item.handle} spacing="tight">
              <Heading element="h3">{item.label}</Heading>
              <Paragraph element="pre">{item.answer}</Paragraph>
            </TextContainer>
          ))}
        </div>
      )}
    </div>
  );
}
